"use client"

import { ErrorPage } from "@local/ui/src/components/ErrorPage"

export default function RootError(props: {
  error: Error & { digest?: string }
  retry: () => void
}) {
  return <ErrorPage {...props} />
}
